import { loadable } from '@change-corgi/core-react/loadable';

import type { AppRoute } from '#src/shared/routes';

import { Loading } from '#src/app/shared/routes';

export const ROUTES: readonly AppRoute[] = [
	{
		id: 'ambassadors-terms',
		path: '/ambassadors/terms',
		priority: 10, // to be matched before /ambassadors/:token
		component: loadable(async () => import(/* webpackChunkName: "pages/ambassadors-terms" */ './index'), {
			exportName: 'AmbassadorsTerms',
			fallback: Loading,
		}),
		frame: {
			header: true,
			footer: true,
		},
		ssr: {
			enabled: true,
			seo: false,
		},
	},
];
